import React from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "./sidebar";
import { SidebarProvider } from "../../context/SideBarConext";

function DashboardLayout() {
  return (
    <SidebarProvider>
      <div className="flex flex-col md:flex-row min-h-screen bg-gray-100">
        <Sidebar />
        <main className="flex-grow md:w-[calc(100%-16rem)] overflow-x-hidden">
          <Outlet />
        </main>
      </div>
    </SidebarProvider>
  );
}

export default DashboardLayout;